/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/prop-types */

import { ICellTextProps } from "ka-table/props";
import React from "react";
import { Popover, ScrollArea } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

const formatValue = (val: any): string => {
  if (val === null || val === undefined) return "—";
  if (typeof val === "boolean") return val ? "Yes" : "No";
  if (typeof val === "object") return JSON.stringify(val);
  return String(val);
};

const formatKey = (key: string): string =>
  key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

const DropdownCell: React.FC<ICellTextProps> = React.memo(
  ({
    column, dispatch, rowKeyValue, ...props
  }) => {
    const [opened, { close, open }] = useDisclosure(false);
    const value = props.rowData[`${column.key}`];

    if (!value || typeof value !== "object") {
      return <span className="text-sm text-gray-400">—</span>;
    }

    const entries = Object.entries(value).filter(([key]) => key !== column.key);
    const previewEntries = entries.slice(0, 3);

    return (
      <div className="relative w-full">
        <Popover withinPortal opened={opened} position="bottom-start" offset={4} shadow="md" width={380}>
          <Popover.Target>
            <div
              onMouseEnter={open}
              onMouseLeave={close}
              className="cursor-pointer flex flex-wrap gap-1 items-center"
            >
              {previewEntries.map(([key, val]) => (
                <span
                  key={key}
                  className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-gray-100 text-[11px] text-gray-600 max-w-[140px] truncate"
                >
                  <span className="text-gray-400 font-medium truncate">{formatKey(key)}:</span>
                  <span className="truncate">{formatValue(val)}</span>
                </span>
              ))}
              {entries.length > 3 && (
                <span className="text-[11px] text-purple-600 font-medium">
                  +{entries.length - 3} more
                </span>
              )}
            </div>
          </Popover.Target>
          <Popover.Dropdown p={0}>
            <ScrollArea.Autosize mah={320}>
              <div className="divide-y divide-gray-100">
                {entries.map(([key, val]) => (
                  <div key={key} className="flex items-start gap-3 px-3 py-2">
                    <span className="text-xs font-medium text-gray-500 min-w-[120px] max-w-[140px] truncate pt-0.5">
                      {formatKey(key)}
                    </span>
                    <span className="text-xs text-gray-800 break-all flex-1">
                      {formatValue(val)}
                    </span>
                  </div>
                ))}
              </div>
            </ScrollArea.Autosize>
          </Popover.Dropdown>
        </Popover>
      </div>
    );
  },
);

export default DropdownCell;
